import React from 'react';
import '../App.css';
import ImageCarousel from './ImageCarousel';
import ImageCarouselVertical from './ImageCarouselVertical';
import './Home.css';
import { Link } from 'react-router-dom';

function Home() {
    const horizontalImages = [
        'images/carousel-interieur/interieur-1.jpg',
        'images/carousel-interieur/interieur-2.jpg',
        'images/carousel-interieur/interieur-3.jpg',
        'images/carousel-interieur/interieur-4.jpg',
        'images/carousel-interieur/interieur-5.jpg'
    ];

    const verticalImages = [
        'images/carousel-plats/plat-c2-1.jpg',
        'images/carousel-plats/plat-c2-2.jpg',
        'images/carousel-plats/plat-c2-3.jpg',
        'images/carousel-plats/plat-c2-4.jpg',
        'images/carousel-plats/plat-c2-5.jpg'
    ];

    return (
        <div className='home'>

            {/* ── Intro ───────────────────────────────────────────── */}
            {/* <div className='home-intro'>
                <span className='home-intro-eyebrow'>Notre cuisine</span>
                <h2 className='home-intro-title'>
                    L'art de cuisiner,<br />
                    <em>sublimé à chaque assiette</em>
                </h2>
                <div className='home-intro-divider' />
                <p className='home-intro-text'>
                    Découvrez l'univers Trilogie à travers nos créations. Chaque plat est 
                    une rencontre entre tradition et modernité, façonné avec passion et 
                    des produits soigneusement sélectionnés.
                </p>
            </div> */}

            {/* ── Galerie ─────────────────────────────────────────── */}
            <div className='home-gallery'>

                {/* Rangée 1 : Carousel horizontal + texte */}
                <div className='gallery-featured'>
                    <div className='gallery-featured-carousel'>
                        <ImageCarousel images={horizontalImages} />
                    </div>
                    <div className='gallery-featured-text'>
                        <span className='gallery-text-number'>01</span>
                        <span className='gallery-text-label'>Notre univers</span>
                        <h3 className='gallery-text-heading'>
                            Trilogie, au coeur des Vennes
                        </h3>
                        <p className='gallery-text-body'>
                            Chez Trilogie, l'ambiance conviviale se mêle à une cuisine créative et soignée pour offrir une expérience gastronomique sans prétention, mais toujours pleine de caractère.
                        </p>
                        <Link
                            to='https://bookings.zenchef.com/results?rid=379037&pid=1001'
                            target='_blank'
                            className='gallery-text-cta'
                        >
                            Réserver une table
                            <span className='gallery-text-cta-arrow' />
                        </Link>
                    </div>
                </div>

                {/* Rangée 2 : texte + carousel vertical */}
                <div className='gallery-secondary'>
                    <div className='gallery-secondary-text'>
                        <span className='gallery-text-number'>02</span>
                        <span className='gallery-text-label'>Nos créations</span>
                        <h3 className='gallery-text-heading'>
                            Un menu unique qui évolue<br />chaque semaine
                        </h3>
                        <p className='gallery-text-body'>
                            Porté par une véritable recherche culinaire et un
                            travail précis autour de l'assiette. Des produits
                            ultra-frais, soigneusement sélectionnés auprès de
                            nos artisans et producteurs locaux.
                        </p>
                        <Link to='/menu' className='gallery-text-cta'>
                            Découvrir le menu
                            <span className='gallery-text-cta-arrow' />
                        </Link>
                    </div>
                    <div className='gallery-secondary-carousel'>
                        <ImageCarouselVertical images={verticalImages} />
                    </div>
                </div>

            </div>

            {/* ── Citation finale ─────────────────────────────────── */}
            {/* <div className='home-closing'>
                <p className='home-closing-quote'>
                    « La cuisine, c'est quand les choses ont le goût de ce qu'elles sont. »
                </p>
                <span className='home-closing-author'>— Curnonsky</span>
            </div> */}
        </div>
    );
}

export default Home;
